import React, { useEffect, useState } from 'react'
import ActionArea from '../../components/ActionArea'
import Input from '../../components/UI/Input'
import SmartSearch from '../../components/UI/SmartSearch'
import { useLoading } from '../../context/LoadingProvider/useLoading'
import { getDecksStatusList } from '../../services/deckStatus'
import { notificationError } from '../../services/notification'
import direction from '../../utils/filterDirectionOrder'
import { IDeckStatus } from './types'
import { inputTypeNumberValidation, onlyNumbers, returnOnlyNumbersAsInteger } from '../../utils/formValidation'
import numeral from 'numeral'
import { onlyNumbersAsString } from '../../utils/stringUtils'

type Form = {
  min: string;
  max: string;
  minWager: string;
  maxWager: string;
  minRemaining: string;
  maxRemaining: string;
  days: string;
}

function DeckFilter(props: { setDecks: (decks: IDeckStatus[]) => void, setGeneratedAt: React.Dispatch<React.SetStateAction<string>> }) {
  const loading = useLoading()
  const [search, setSearch] = useState('')
  const [form, setForm] = useState<Form>({
    min: '',
    max: '',
    minWager: '',
    maxWager: '',
    minRemaining: '',
    maxRemaining: '',
    days: ''
  })
  const [playedInLastDays, setPlayedInLastDays] = useState(false)
  const [params, setParams] = useState({
    fieldOrder: '',
    directionOrder: '',
    search: {
      id: null,
      name: '',
      type: '',
    }
  })
  
  /*const handleEnter = (event: KeyboardEvent) => {
    if (loading.loading) return;
    if (!event.repeat && event.key === 'Enter') {
      onRefresh()
    }
  }

  useEffect(() => {
    document.addEventListener("keydown", handleEnter)
    return () => document.removeEventListener("keydown", handleEnter)
  })
*/
  const [validSearch, setValidSearch] = useState(false)
  const onRefresh = async (order?: string, directionparam?: string) => {
    if (!validSearch || !params.search.type) return notificationError("Please select a valid search")
    if (form.days && parseInt(form.days.toString()) <= 0) return notificationError("Invalid last days")
    loading.addLoading()
    let requestParams = {
      [`${params.search.type}Id`]: params.search.id,
      fieldOrder: '',
      directionOrder: ''
    }
    if (order && directionparam) {
      requestParams = {
        ...requestParams,
        fieldOrder: order || '',
        directionOrder: directionparam === 'ascend' ? direction.asc : direction.desc,
      }
      setParams({
        ...params,
        fieldOrder: order || '',
        directionOrder: directionparam === 'ascend' ? direction.asc : direction.desc,
      })
    }
    const payload = {
      ...requestParams,
      ...form,
      days: playedInLastDays ? form.days : ''
    }

    const response = await getDecksStatusList(payload)
    loading.removeLoading()
    props.setGeneratedAt(response.generatedAt)
    return props.setDecks(response.itens)
  }

  return (
    <div>
      <ActionArea 
        buttonAction={onRefresh} 
        disabled={!validSearch} 
        buttonText="Search" 
        buttonStyle={{marginBottom: 10}}
      >
        <>
          <SmartSearch
            value={search}
            onChange={(e: string) => setSearch(e)}
            onValidSearch={setValidSearch}
            label='Smart Search'
            status="active"
            searchBy={['charity', 'location']}
            onObjValueChange={(e: any) => setParams({ ...params, search: e })}
            autoFocus
          />
          <Input
            label={'Min actual payout (%)'}
            onChange={(e: any) => setForm({...form, min: e.target.value})}
            value={form.min}
            type="number"
            onKeyPress={inputTypeNumberValidation}
            min="0"
          />
          <Input
            label={'Max actual payout (%)'}
            onChange={(e: any) => setForm({...form, max: e.target.value})}
            value={form.max}
            type="number"
            onKeyPress={inputTypeNumberValidation}
            min="0"
          />
          <Input
            label={'Min current total wager ($)'}
            onChange={(e: any) => setForm({...form, minWager: e.target.value})}
            value={form.minWager}
            type="number"
            onKeyPress={inputTypeNumberValidation}
            min="0"
          />
          <Input
            label={'Max current total wager ($)'}
            onChange={(e: any) => setForm({...form, maxWager: e.target.value})}
            value={form.maxWager}
            type="number"
            onKeyPress={inputTypeNumberValidation}
            min="0"
          />
          <Input
            label={'Min remaining tickets (%)'}
            onChange={(e: any) => setForm({...form, minRemaining: e.target.value})}
            value={form.minRemaining}
            type="number"
            onKeyPress={inputTypeNumberValidation}
            min="0"
          />
          <Input
            label={'Max remaining tickets (%)'}
            onChange={(e: any) => setForm({...form, maxRemaining: e.target.value})}
            value={form.maxRemaining}
            type="number"
            onKeyPress={inputTypeNumberValidation}
            min="0"
          />
          <div className="input-component">
            <div className="input-component__label">Not played in last</div>
            <div className="input-component__input" style={{margin: 'auto'}}>
              <input type="checkbox" id={'form'} onChange={(e) => setPlayedInLastDays(e.target.checked)} />
            </div>
          </div>
          <Input
            label="Days"
            disabled={!playedInLastDays}
            value={form.days}
            onChange={(e: any) => setForm({...form, days: e.target.value})}
            type="number"
            onKeyPress={inputTypeNumberValidation}
            min="0"
          />
        </>
      </ActionArea>
    </div>
  )
}

export default DeckFilter
